import { render } from "./DialogDownloadDb.vue?vue&type=template&id=2215eb97"
import script from "./DialogDownloadDb.vue?vue&type=script&lang=js"
export * from "./DialogDownloadDb.vue?vue&type=script&lang=js"

import "./DialogDownloadDb.vue?vue&type=style&index=0&id=2215eb97&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__